import React from 'react'
import EventList from '../../features/admin/EventList'

const EventListPage = () => {
  return <EventList/>
}

export default EventListPage